// 261010 P9D D1 — luật thanh dính khung 8 bước (THUẦN: 0 antd/router). Observer xem sentinel 1 px nằm NGAY TRÊN thanh trong luồng, không xem chính thanh.
// Stick khi ratio === 0 (sentinel khỏi mép trên vùng cuộn). Unstick khi ratio === 1 VÀ sentinel nằm dưới mép trên vùng cuộn quá `hyst` px — tức thanh trong luồng đã ngồi lại đúng chỗ thanh dính.
// Lỗi U8 (28/10): bản cũ so `top > H + hyst` với H = chiều cao THANH; lượt 5 thu header về một hàng (~60 px < H + hyst) nên sentinel ở đầu trang không bao giờ vượt ngưỡng ⇒ thanh kẹt ở trạng thái dính, để lại khoảng trống. Ngưỡng nhả không được phụ thuộc chiều cao header / thanh.
// Debounce unstick 80 ms nằm ở component.

export const STICKY_HYST_PX = 4;
export const UNSTICK_DEBOUNCE_MS = 80;

export interface StickyGeom {
  /** intersectionRatio của sentinel. */
  ratio: number;
  /** boundingClientRect.top của sentinel. */
  top: number;
  /** Mép trên vùng cuộn (toạ độ viewport) — chỗ thanh dính neo; cùng hệ toạ độ với `top`. */
  edge: number;
  /** Hysteresis px (mặc định 4). */
  hyst: number;
}

export function shouldUnstick(g: StickyGeom): boolean {
  return g.ratio === 1 && g.top > g.edge + g.hyst;
}

/** Trạng thái stuck kế tiếp từ một mẫu geometry. `wasStuck` = đang dính (hysteresis). */
export function stuckAfter(g: StickyGeom & { wasStuck?: boolean }): boolean {
  if (g.ratio === 0) return true;
  if (g.wasStuck) return !shouldUnstick(g);
  return false;
}

/**
 * Vòng sửa 1 (#2) — tỉ lệ sentinel nằm trong vùng nhìn của vùng cuộn, tính từ geometry HIỆN TẠI (không phụ thuộc lúc IO bắn).
 * Cần vì IntersectionObserver chỉ bắn khi băng qua ngưỡng: cuộn lên tiếp trong lúc sentinel vẫn thấy hết thì không có mẫu mới ⇒ không bao giờ đạt `top > H + hyst`.
 */
export function sentinelRatioOf(s: { top: number; bottom: number }, v: { top: number; bottom: number }): number {
  const h = s.bottom - s.top;
  if (h <= 0) return s.top >= v.top && s.top <= v.bottom ? 1 : 0;
  const visible = Math.min(s.bottom, v.bottom) - Math.max(s.top, v.top);
  return Math.max(0, Math.min(1, visible / h));
}
